/**
 * Syncs Fusion Aperture intro phase from the hub hero to the marketing nav shell.
 */
import React, { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const FusionMsiIntroContext = createContext(null);

export function FusionMsiIntroProvider({ children }) {
  const [introPhase, setIntroPhase] = useState('idle');

  const value = useMemo(
    () => ({
      introPhase,
      setIntroPhase,
    }),
    [introPhase],
  );

  return (
    <FusionMsiIntroContext.Provider value={value}>{children}</FusionMsiIntroContext.Provider>
  );
}

FusionMsiIntroProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useFusionMsiIntro() {
  const ctx = useContext(FusionMsiIntroContext);
  return ctx ?? { introPhase: 'idle', setIntroPhase: () => {} };
}

/** Matches page dim during intro — shared with nav */
export const FUSION_MSI_INTRO_DIM_OPACITY = 0.32;
